module.exports = __webpack_public_path__ + "static/img/pic3@2x.74bd6fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liveimg/pic3@2x.png
// module id = 9MkA
// module chunks = 1